<template>
    <a-card
        class="file-progress-card"
    >   
        <span slot="title">
            <a-icon type="upload" />
            Feltöltések
        </span>
        <template
        >
            <FileUploadProgressList />
        </template>
        <template class="ant-card-actions" slot="actions">
            <span
                v-on:click="clearFileUploadProgress"
            >
                Befejezettek törlése
            </span>
        </template>
    </a-card>
</template>

<script>
import FileUploadProgressList from '@/components/app/file_upload_components/FileUploadProgressList.vue';
import { CLEAR_COMPLETED_STATUS_FILES } from '../../../store/mutation_types';

export default {
    components: {
        FileUploadProgressList
    },

    data() {
        return {
        }
    },
    
    methods: {
        clearFileUploadProgress(e) {
            this.$store.commit({
                type: CLEAR_COMPLETED_STATUS_FILES
            })
        }
    }
    

    
}
</script>

<style lang="scss" >
    .file-progress-card {
        width: 100%;
        .ant-card-body {
            max-height: 335px;
            overflow-y: scroll;
        }
    }
    
        
</style>
